import Swal from 'sweetalert2'

const isBackend = window.location.pathname.toLowerCase().includes('/backend')

const backendCustomClass = {
  title: 'emphasis-title',
  cancelButton: 'btn btn-secondary me-2',
  confirmButton: 'btn btn-primary',
  popup: 'my-swal-popup text-gray600'
}

const frontendCustomClass = {
  title: 'emphasis-title',
  cancelButton: 'btn btn-secondary me-2',
  confirmButton: 'btn btn-primary col-12 col-md-6 mx-2',
  popup: 'my-swal-popup text-gray600',
  actions: 'w-100 px-3'
}
let swalWithDefaults = Swal.mixin({
  cancelButtonText: '取消',
  confirmButtonText: '確定',
  showCancelButton: true,
  reverseButtons: true,
  customClass: isBackend ? backendCustomClass : frontendCustomClass,
  buttonsStyling: false
})

export default function swal(options) {
  return swalWithDefaults.fire(options)
}
